// Small shared helpers for the lead and signup surfaces (card shell, phone,
// ago labels, initials, the My Calendly input). Moved from the retired Lead
// Handoffs page (2026-09-28).

export const CARD =
  'rounded-xl bg-white shadow-[0_1px_2px_rgba(15,23,42,0.04),0_2px_8px_rgba(15,23,42,0.05)]';

export const formatPhone = (p) => {
  const d = String(p || '').replace(/\D/g, '');
  if (d.length === 10)
    return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
  if (d.length === 11 && d.startsWith('1')) {
    return `(${d.slice(1, 4)}) ${d.slice(4, 7)}-${d.slice(7)}`;
  }
  return p || '';
};

export const agoLabel = (d, nowMs = Date.now()) => {
  if (!d) return '';
  const ms = nowMs - new Date(d).getTime();
  const days = Math.floor(ms / 86400000);
  if (days > 0) return `${days}d ago`;
  const hours = Math.floor(ms / 3600000);
  if (hours > 0) return `${hours}h ago`;
  return `${Math.max(1, Math.floor(ms / 60000))}m ago`;
};

// My Calendly input helper: forgiving in, strict out. Bare "calendly.com/…"
// pastes get https:// prepended and http upgrades to https; anything that
// still isn't a calendly.com link comes back with a short human error for
// INLINE display (never a toast — a paragraph of server text in a toast is
// exactly the wall-of-text look we're avoiding). Mirrors the server's
// allowlist, which remains the authority.
export const normalizeCalendlyUrl = (raw) => {
  const trimmed = String(raw || '').trim();
  if (!trimmed) return { url: '' };
  let candidate = trimmed;
  if (/^(www\.)?calendly\.com\//i.test(candidate)) {
    candidate = `https://${candidate}`;
  } else if (/^http:\/\//i.test(candidate)) {
    candidate = candidate.replace(/^http:\/\//i, 'https://');
  }
  let parsed = null;
  try {
    parsed = new URL(candidate);
  } catch (e) {
    parsed = null;
  }
  const host = parsed?.hostname?.toLowerCase() || '';
  const isCalendly =
    parsed?.protocol === 'https:' &&
    (host === 'calendly.com' || host.endsWith('.calendly.com'));
  if (!isCalendly) {
    return {
      error:
        'Only Calendly links work here. Yours should look like calendly.com/your-name/your-minutes.',
    };
  }
  // Someone typed the example back at us instead of pasting their real
  // link. Catch it here or a made-up link saves fine and every booking
  // send quietly points veterans at a calendar that is not theirs.
  if (/your-?name|your-?minutes/i.test(parsed.pathname)) {
    return {
      error:
        'That is the example, not your link. In Calendly, use Copy link on your event and paste it here.',
    };
  }
  if (candidate.length > 255) {
    return {
      error:
        'That link is too long to save. Use the plain link without tracking extras.',
    };
  }
  return { url: candidate };
};

export const initialsOf = (name) =>
  (name || '?')
    .split(/\s+/)
    .map((w) => w[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);
